import React from 'react'
import Apropos from '../../components/apropos/Apropos'
import HeaderBanner from '../../components/header-banner/HeaderBanner'
import Footer from '../../components/footer/Footer'

const AproposPage = () => {
  return (
    <>
       <HeaderBanner title={"A propos du projet"} colored={"GireAuSol"} isHome={false} />
       <Apropos />
        <Footer />
    </>
  )
}

export default AproposPage
